
export function createUrlFromTemplate(template: string, replacements): string {
    let url = decodeURI(template);
    for (let e in replacements) {
        if (Array.isArray(replacements[e])) {
            let replacement: string = '';
            for (var i = 0; i < replacements[e].length; i++) {
                replacement += replacements[e][i] + (i < replacements[e].length - 1 ? `&${e}=` : '');
            }
            url = url.replace(`{${e}}`, replacement);
        }
        else {
            url = url.replace(`{${e}}`, replacements[e]);
        }
    }

    return url;
}
